import { memoize } from "decko";

export default class Urls {
  @memoize
  static parseQueryString(query) {
    const envVars = {};

    if (query) {
      query.replace(/^\?/, "").split("&").forEach((keyValuePair) => {
        let [key, value] = keyValuePair.split("=");

        if (value === "null") value = null;
        else if (value === "false") value = false;
        else if (value === "true") value = true;
        else value = value === undefined ? true : decodeURIComponent(value);
        envVars[key] = value;
      });
    }

    return envVars;
  }

  static objectToQueryString(paramObj, withoutUrlEncode = false) {
    if (!paramObj) return "";

    return Object.keys(paramObj).map((key) => {
      const values = paramObj[key];

      if (!key || values === undefined || values === null) return null;

      return (Array.isArray(values) ? values : [values]).map((value) => {
        return `${withoutUrlEncode ? key : encodeURIComponent(key)}${
          `=${(withoutUrlEncode ? value : encodeURIComponent(value))}`}`;
      }).join("&");
    }).filter(Boolean).join("&");
  }
}
